import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import { ReportFormType } from '../../../../pages/Finance/Reports'

export default function FilesPerUserReportForm(props: ReportFormType): ReactElement {
    return <ReportForm title="Nieuwe dossiers" generationType={DocumentGenerationType.FileCreation} {...props} />
}
